<template>
  <div id="navigation_menu">
    <!-- OPCIONES DE MENU DESPLEGABLE CUANDO ESTÁ EN MODO MOBILE -->
    <nav id="navbar_main" v-if='!preload' class="mobile-offcanvas navbar navbar-expand-lg navbar-dark bg-light">
      <!-- X para cerrar menu mobile -->
      <div class="d-flex flex-row justify-content-end">
        <div class="offcanvas-header">
          <button @click="close_offcanvas(null)" class="btn-close float-end" aria-label="Close button"></button>
        </div>
      </div>
      <!-- Desplegable con las opciones de navegación del menú mobile -->
      <div class="d-flex flex-row justify-content-end">
        <div class="bg-light">
          <span class="d-flex flex-row pt-4 pb-2 cursor" @click="close_offcanvas('/credito-coche')">
            <svg id="coche" class="color-svg" width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M17.91 1.13625C17.685 0.4725 17.055 0 16.3125 0H3.9375C3.195 0 2.57625 0.4725 2.34 1.13625L0 7.875V16.875C0 17.4937 0.50625 18 1.125 18H2.25C2.86875 18 3.375 17.4937 3.375 16.875V15.75H16.875V16.875C16.875 17.4937 17.3813 18 18 18H19.125C19.7437 18 20.25 17.4937 20.25 16.875V7.875L17.91 1.13625ZM4.33122 2.25H15.9075L17.0775 5.625H3.16122L4.33122 2.25ZM2.25 13.5H18V8.2575L17.8763 7.875H2.385L2.25 8.2575V13.5ZM5.0625 9C4.13052 9 3.375 9.75552 3.375 10.6875C3.375 11.6195 4.13052 12.375 5.0625 12.375C5.99448 12.375 6.75 11.6195 6.75 10.6875C6.75 9.75552 5.99448 9 5.0625 9ZM13.5 10.6875C13.5 9.75552 14.2555 9 15.1875 9C16.1195 9 16.875 9.75552 16.875 10.6875C16.875 11.6195 16.1195 12.375 15.1875 12.375C14.2555 12.375 13.5 11.6195 13.5 10.6875Z" fill="#333333" />
            </svg>
            <p class="h4 pl-3">Crédito coche</p>
          </span>
          <span class="d-flex flex-row pt-4 pb-2 cursor" @click="close_offcanvas('/como-funciona')">
            <svg id="bombilla" class="color-svg" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22.4545 11.8182H26V14.1818H22.4545V11.8182ZM0 11.8182H3.54545V14.1818H0V11.8182ZM14.1818 0V3.54545H11.8182V0H14.1818ZM4.63273 2.95455L7.15 5.48364L5.47182 7.15L2.95455 4.64455L4.63273 2.95455ZM18.85 5.47182L21.3555 2.95455L23.0455 4.64455L20.5282 7.15L18.85 5.47182ZM13 5.90909C14.8806 5.90909 16.6842 6.65617 18.014 7.98597C19.3438 9.31577 20.0909 11.1194 20.0909 13C20.0909 15.6236 18.6609 17.9164 16.5455 19.1455V21.2727C16.5455 21.5862 16.4209 21.8868 16.1993 22.1084C15.9777 22.33 15.6771 22.4545 15.3636 22.4545H10.6364C10.3229 22.4545 10.0223 22.33 9.80069 22.1084C9.57906 21.8868 9.45455 21.5862 9.45455 21.2727V19.1455C7.33909 17.9164 5.90909 15.6236 5.90909 13C5.90909 11.1194 6.65617 9.31577 7.98597 7.98597C9.31577 6.65617 11.1194 5.90909 13 5.90909ZM15.3636 23.6364V24.8182C15.3636 25.1316 15.2391 25.4322 15.0175 25.6539C14.7959 25.8755 14.4953 26 14.1818 26H11.8182C11.5047 26 11.2041 25.8755 10.9825 25.6539C10.7609 25.4322 10.6364 25.1316 10.6364 24.8182V23.6364H15.3636ZM11.8182 20.0909H14.1818V17.5736C16.2264 17.0536 17.7273 15.1982 17.7273 13C17.7273 11.7462 17.2292 10.5438 16.3427 9.65731C15.4562 8.77078 14.2537 8.27273 13 8.27273C11.7462 8.27273 10.5438 8.77078 9.65731 9.65731C8.77078 10.5438 8.27273 11.7462 8.27273 13C8.27273 15.1982 9.77364 17.0536 11.8182 17.5736V20.0909Z"
                fill="#333333" />
            </svg>
            <p class="h4 pl-3">¿Cómo funciona?</p>
          </span>
          <span class="d-flex flex-row pt-4 pb-2 cursor" @click="close_offcanvas('/quienes-somos')">
            <svg id="cara" class="color-svg" width="19" height="26" viewBox="0 0 19 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.23876 1C6.5988 1 4.51311 1.78255 3.10917 3.21738C1.70552 4.6522 1.01703 6.70026 1.01703 9.13581C1.01703 10.145 1.46601 12.095 1.8344 13.2446C1.68109 13.3749 1.52581 13.4582 1.37672 13.6848C1.12569 14.0676 0.941777 14.6041 1.01703 15.2499C1.23773 17.1147 2.41057 17.7812 2.79862 17.9727C2.94772 18.8451 3.39895 19.922 4.1391 21.0227C4.93204 22.2028 6.02683 23.3352 7.35889 23.9729C7.3836 23.985 7.39988 24.0102 7.42431 24.0229C7.90446 24.5951 8.58284 25 9.38589 25C10.1887 25 10.867 24.5945 11.3472 24.0217C11.3719 24.0097 11.3882 23.9852 11.4126 23.9729C12.7407 23.3327 13.8133 22.2014 14.5998 21.0218C15.3313 19.9234 15.7749 18.8409 15.924 17.9727C16.3079 17.7914 17.5155 17.1436 17.7382 15.2662C17.814 14.6182 17.616 14.0698 17.3622 13.6848C17.2111 13.4563 17.0578 13.3771 16.9045 13.2446C17.2724 12.081 17.7545 10.2792 17.7545 8.3044C17.7545 7.39745 17.5689 6.15666 16.9537 5.07591C16.3758 4.06114 15.3299 3.22131 13.8482 3.11938C13.176 2.10265 11.7232 1 9.23876 1ZM9.23876 2.04341C11.5903 2.04341 12.716 3.12949 13.1125 3.85308C13.2026 4.02211 13.3781 4.12825 13.5702 4.13022C14.8469 4.13022 15.552 4.7457 16.0383 5.59761C16.5243 6.44924 16.7085 7.55245 16.7085 8.3044C16.7085 10.2385 16.1815 12.1414 15.8257 13.2283C15.7541 13.4582 15.8479 13.7073 16.0546 13.8314C16.1447 13.8862 16.3505 14.0493 16.496 14.2717C16.6414 14.4941 16.7391 14.7619 16.6923 15.1531C16.4918 16.8347 15.3192 17.1585 15.3192 17.1585C15.1229 17.2216 14.982 17.3949 14.9595 17.5987C14.8983 18.1755 14.4611 19.3452 13.7336 20.4358C13.0061 21.5261 12.007 22.5653 10.9058 23.0772C10.8201 23.1156 10.7463 23.1788 10.6935 23.2566C10.4116 23.675 9.93342 23.9566 9.38589 23.9566C8.83807 23.9566 8.36017 23.6755 8.07826 23.2555C8.02491 23.1783 7.95163 23.1148 7.86571 23.076C6.76053 22.5647 5.75559 21.5241 5.02161 20.4338C4.28792 19.3433 3.83838 18.1718 3.77941 17.5968C3.7547 17.4033 3.62189 17.2382 3.43629 17.1728C3.43629 17.1728 2.26148 16.8201 2.06324 15.1348C2.01607 14.7414 2.11659 14.4708 2.25923 14.2543C2.40215 14.0384 2.59 13.8898 2.68434 13.8306C2.89886 13.7042 2.99574 13.4448 2.91403 13.2097C2.5973 12.3006 2.06324 9.80408 2.06324 9.13581C2.06324 6.89597 2.68434 5.1374 3.86112 3.93479C5.0379 2.73218 6.80349 2.04341 9.23876 2.04341ZM13.2105 6.0216C13.1945 6.02581 13.1776 6.03227 13.1616 6.03788C13.151 6.04209 13.1395 6.04855 13.1288 6.05417C13.0881 6.06624 13.0516 6.08281 13.0145 6.10331C13.0041 6.10724 12.9912 6.1137 12.9808 6.11959V6.13588C12.9645 6.14627 12.948 6.15581 12.9317 6.16845C12.9196 6.17884 12.9095 6.18839 12.8991 6.20102C12.8926 6.21141 12.8867 6.2232 12.8828 6.23359C12.8581 6.26448 12.8356 6.29761 12.8174 6.33243V6.34871C12.8109 6.3591 12.805 6.3709 12.8008 6.38129C12.7581 6.46271 12.5512 6.82577 12 7.27812C11.3834 7.78269 10.4032 8.3044 8.86278 8.3044C7.88199 8.3044 6.65186 8.31254 5.59386 8.69553C5.06429 8.88703 4.57011 9.1827 4.20452 9.64122C3.83866 10.0997 3.63228 10.7091 3.63228 11.4346C3.63031 11.6219 3.72859 11.7974 3.89173 11.8934C4.05543 11.9872 4.25507 11.9872 4.41904 11.8934C4.58274 11.7974 4.68046 11.6219 4.67849 11.4346C4.67849 10.8989 4.80934 10.5605 5.02161 10.2935C5.23389 10.0262 5.54893 9.82009 5.95327 9.67295C6.76249 9.38178 7.89828 9.3478 8.86278 9.3478C10.6444 9.3478 11.897 8.72782 12.6711 8.0924C12.9305 7.88041 13.1265 7.66841 13.2922 7.47271C13.799 8.28615 14.6164 9.82037 14.6164 11.4346C14.6141 11.6219 14.7127 11.7974 14.8758 11.8934C15.0395 11.9872 15.2392 11.9872 15.4029 11.8934C15.5666 11.7974 15.6646 11.6219 15.6623 11.4346C15.6623 8.8421 14.0888 6.71879 13.8153 6.36416V6.34787C13.8032 6.33159 13.7726 6.27206 13.7664 6.26616C13.7558 6.25409 13.7462 6.24398 13.7336 6.23359L13.7173 6.21731C13.7131 6.20692 13.7066 6.19512 13.701 6.18473H13.6847C13.6437 6.13784 13.5924 6.09938 13.5376 6.07045L13.521 6.05417C13.5107 6.04799 13.4989 6.04209 13.4885 6.03788H13.4722C13.4618 6.03171 13.45 6.02581 13.4393 6.0216H13.2105ZM9.67791 10.9129C7.79607 10.9129 6.84533 12.0653 6.77064 13.5074H7.91793C7.99066 12.5535 8.62215 11.9504 9.63214 11.9504C10.6306 11.9504 11.2849 12.5572 11.2849 13.3852C11.2849 14.1004 10.9757 14.528 10.199 15.0034C9.28256 15.5512 8.85997 16.1516 8.86784 17.0332V17.6437H10.0303V17.2166C10.0303 16.5143 10.2827 16.1294 11.1318 15.629C11.9885 15.1146 12.524 14.3716 12.524 13.324C12.524 11.9487 11.3649 10.9129 9.67791 10.9129ZM9.54004 18.8808C8.99868 18.8808 8.60642 19.2644 8.60642 19.8122C8.60642 20.3521 8.99672 20.7435 9.54004 20.7435C10.0836 20.7435 10.4585 20.3521 10.4585 19.8122C10.4591 19.2644 10.0814 18.8808 9.54004 18.8808Z"
                fill="#333333" />
            </svg>
            <p class="h4 pl-3">¿Quienes somos?</p>
          </span>
          <a :href="$blogURL" target='_blank'>
          <span class="d-flex flex-row pt-4 pb-2 cursor">
            <svg id="blog" class="color-svg" width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.1391 3.77681H19.872V1.65766C19.872 1.25304 19.544 0.925 19.1393 0.925H1.65766C1.25304 0.925 0.925 1.25304 0.925 1.65766V18.8424C0.925 20.0735 1.92648 21.075 3.15758 21.075H20.6391C21.8702 21.075 22.8717 20.0735 22.8717 18.8424V4.50947C22.8717 4.10484 22.5437 3.77681 22.1391 3.77681ZM2.39033 2.39033H18.4067V4.50938V18.8424C18.4067 19.1118 18.4547 19.3703 18.5426 19.6097H3.15758C2.7346 19.6097 2.39033 19.2654 2.39033 18.8424V2.39033ZM20.6392 19.6097C20.2163 19.6097 19.872 19.2654 19.872 18.8424V5.24213H21.4064V18.8424C21.4064 19.2654 21.0621 19.6097 20.6392 19.6097Z" fill="#333333" stroke="#333333" stroke-width="0.15" />
              <path d="M3.84321 9.56688H16.9544C17.359 9.56688 17.6871 9.23884 17.6871 8.83421V4.43891C17.6871 4.03429 17.359 3.70625 16.9544 3.70625H3.84321C3.43858 3.70625 3.11055 4.03429 3.11055 4.43891V8.83421C3.11055 9.23884 3.43858 9.56688 3.84321 9.56688ZM4.57587 5.17158H16.2217V8.10155H4.57587V5.17158Z" fill="#333333" stroke="#333333" stroke-width="0.15" />
              <path d="M3.84321 18.2118H9.56997C9.9746 18.2118 10.3026 17.8837 10.3026 17.4791V11.7519C10.3026 11.3473 9.9746 11.0192 9.56997 11.0192H3.84321C3.43858 11.0192 3.11055 11.3473 3.11055 11.7519V17.4791C3.11055 17.8837 3.43858 18.2118 3.84321 18.2118ZM4.57588 12.4845H8.83731V16.7464H4.57588V12.4845Z" fill="#333333" stroke="#333333" stroke-width="0.15" />
              <path d="M16.9539 11.0192H11.4155C11.0108 11.0192 10.6828 11.3473 10.6828 11.7519C10.6828 12.1565 11.0108 12.4846 11.4155 12.4846H16.9539C17.3585 12.4846 17.6865 12.1565 17.6865 11.7519C17.6865 11.3473 17.3585 11.0192 16.9539 11.0192Z" fill="#333333" stroke="#333333" stroke-width="0.15" />
              <path d="M16.9539 16.7463H11.4155C11.0108 16.7463 10.6828 17.0743 10.6828 17.479C10.6828 17.8836 11.0108 18.2116 11.4155 18.2116H16.9539C17.3585 18.2116 17.6865 17.8836 17.6865 17.479C17.6865 17.0743 17.3585 16.7463 16.9539 16.7463Z" fill="#333333" stroke="#333333" stroke-width="0.15" />
              <path d="M16.9539 13.8825H11.4155C11.0108 13.8825 10.6828 14.2106 10.6828 14.6152C10.6828 15.0198 11.0108 15.3478 11.4155 15.3478H16.9539C17.3585 15.3478 17.6865 15.0198 17.6865 14.6152C17.6865 14.2106 17.3585 13.8825 16.9539 13.8825Z" fill="#333333" stroke="#333333" stroke-width="0.15" />
            </svg>
            <p class="h4 pl-3">Blog</p>
          </span>
        </a>
          <span class="d-flex flex-row pt-4 pb-2 cursor" @click="close_offcanvas('/contacto')">
            <svg id="contacto" class="color-svg" width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.60181 19.1H21.1046C22.5951 19.1 23.8064 17.8869 23.8064 16.3944V3.60518C23.8064 2.11309 22.5951 0.9 21.1046 0.9H3.60181C2.11135 0.9 0.9 2.11309 0.9 3.60518V16.3944C0.9 17.8869 2.11135 19.1 3.60181 19.1ZM2.51904 3.60518C2.51904 3.00759 3.00522 2.52091 3.60181 2.52091H21.1046C21.7012 2.52091 22.187 3.00755 22.187 3.60518V16.3944C22.187 16.9924 21.7012 17.4787 21.1046 17.4787H3.60181C3.0052 17.4787 2.51904 16.9924 2.51904 16.3944V3.60518Z" fill="#333333" stroke="#333333" stroke-width="0.2" />
              <path d="M8.94199 9.9999C8.94199 11.8834 10.4722 13.4157 12.3533 13.4157C14.2348 13.4157 15.7647 11.8834 15.7647 9.9999C15.7647 8.11643 14.2348 6.58408 12.3533 6.58408C10.4722 6.58408 8.94199 8.11642 8.94199 9.9999ZM10.5614 9.9999C10.5614 9.01016 11.3653 8.20536 12.3533 8.20536C13.3417 8.20536 14.1456 9.01018 14.1456 9.9999C14.1456 10.99 13.3417 11.7948 12.3533 11.7948C11.3654 11.7948 10.5614 10.99 10.5614 9.9999Z" fill="#333333" stroke="#333333" stroke-width="0.2" />
              <path
                d="M6.24198 8.66273L6.24196 8.66281C5.8502 10.5491 6.30829 12.4748 7.50182 13.9453C8.6946 15.415 10.4633 16.2578 12.3532 16.2578C12.8003 16.2578 13.1631 15.8944 13.1631 15.4471C13.1631 14.9999 12.8003 14.6365 12.3532 14.6365C10.9532 14.6365 9.64297 14.0116 8.75837 12.9228C7.87436 11.8347 7.53455 10.4028 7.82764 8.99327C8.1915 7.24823 9.60673 5.83127 11.3482 5.46784L11.3484 5.46781C12.752 5.17294 14.1835 5.51372 15.2713 6.39961L15.2713 6.39963C16.3598 7.28569 16.9839 8.59775 16.9839 9.99976V11.184C16.9839 11.521 16.7098 11.7947 16.3744 11.7947C16.0387 11.7947 15.7645 11.521 15.7645 11.184V7.39458C15.7645 6.94738 15.4022 6.58394 14.955 6.58394C14.5079 6.58394 14.1455 6.94738 14.1455 7.39458V11.184C14.1455 12.4148 15.1457 13.4156 16.3744 13.4156C17.6028 13.4156 18.603 12.4148 18.603 11.184V9.99976C18.603 8.1084 17.7607 6.33675 16.2925 5.14283C14.8249 3.94775 12.8999 3.48888 11.0169 3.88142L11.0169 3.88143C8.65345 4.3748 6.73567 6.29534 6.24198 8.66273Z"
                fill="#333333"
                stroke="#333333"
                stroke-width="0.2" />
            </svg>
            <p class="h4 pl-3">Contacto</p>
          </span>

          <span class="d-flex flex-row pt-4 pb-2 cursor dropdown-divider" @click="close_offcanvas('/contacto/#contacta')">
            <svg id="tlf" class="color-svg" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.62 7.79C5.06 10.62 7.38 12.94 10.21 14.38L12.41 12.18C12.69 11.9 13.08 11.82 13.43 11.93C14.55 12.3 15.75 12.5 17 12.5C17.2652 12.5 17.5196 12.6054 17.7071 12.7929C17.8946 12.9804 18 13.2348 18 13.5V17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18C12.4913 18 8.1673 16.2089 4.97918 13.0208C1.79107 9.8327 0 5.50868 0 1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H4.5C4.76522 0 5.01957 0.105357 5.20711 0.292893C5.39464 0.48043 5.5 0.734784 5.5 1C5.5 2.25 5.7 3.45 6.07 4.57C6.18 4.92 6.1 5.31 5.82 5.59L3.62 7.79Z" fill="#333333" />
            </svg>
            <p class="h4 pl-3"><a class="grey" href="tel:+34952864645">952 864 645</a></p>
          </span>
          <span class="d-flex flex-row pt-4 pb-2 cursor" @click="close_offcanvas('/contacto/#enviarMensaje')">
            <svg id="mail" class="color-svg" width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.2 0H19.8C20.3835 0 20.9431 0.237053 21.3556 0.65901C21.7682 1.08097 22 1.65326 22 2.25V15.75C22 16.3467 21.7682 16.919 21.3556 17.341C20.9431 17.7629 20.3835 18 19.8 18H2.2C0.979 18 0 16.9875 0 15.75V2.25C0 1.00125 0.979 0 2.2 0ZM11 7.875L19.8 2.25H2.2L11 7.875ZM2.2 15.75H19.8V4.91625L11 10.53L2.2 4.91625V15.75Z" fill="#333333" />
            </svg>
            <p class="h4 pl-3"><a class="grey" href="mailto:info@ibancar.com">info@ibancar.com</a></p>
          </span>
          <span class="d-flex flex-row pt-4 pb-2 cursor" @click="close_offcanvas('/zona-usuarios')">
            <svg id="clientes" class="color-svg" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 18.92C8.25 18.92 5.819 17.512 4.4 15.4C4.433 13.2 8.8 11.99 11 11.99C13.2 11.99 17.567 13.2 17.6 15.4C16.181 17.512 13.75 18.92 11 18.92ZM11 3.3C11.8752 3.3 12.7146 3.64768 13.3335 4.26655C13.9523 4.88542 14.3 5.72479 14.3 6.6C14.3 7.47521 13.9523 8.31458 13.3335 8.93345C12.7146 9.55232 11.8752 9.9 11 9.9C10.1248 9.9 9.28542 9.55232 8.66655 8.93345C8.04768 8.31458 7.7 7.47521 7.7 6.6C7.7 5.72479 8.04768 4.88542 8.66655 4.26655C9.28542 3.64768 10.1248 3.3 11 3.3ZM11 0C9.55546 0 8.12506 0.284523 6.79048 0.837325C5.4559 1.39013 4.24327 2.20038 3.22183 3.22183C1.15893 5.28473 0 8.08262 0 11C0 13.9174 1.15893 16.7153 3.22183 18.7782C4.24327 19.7996 5.4559 20.6099 6.79048 21.1627C8.12506 21.7155 9.55546 22 11 22C13.9174 22 16.7153 20.8411 18.7782 18.7782C20.8411 16.7153 22 13.9174 22 11C22 4.917 17.05 0 11 0Z" fill="#333333" />
            </svg>
            <p class="h4 pl-3"><a class="grey" href="https://clientes.ibancar.com/" target="_blank" rel="nofollow noopener">Zona de clientes</a></p>
          </span>
        </div>
      </div>
    </nav>
    <!-- Fin Navegacion menú mobile -->

    <!-- OPCIONES DE MENU DESKTOP  -->
    <nav id="desktop"  v-if='!preload' class="p-0" role="navigation">
      <!-- NAVBAR -->
      <div class="d-flex flex-row justify-content-between justify-content-xl-around align-items-center pt-3 pb-3">
        <!-- ZONA LOGO -->
        <div id="logoMenu" class="">
          <router-link to="/">
            <img  id="ibancarLogo" class="img-fluid" src="@/assets/img/logo_ibancar_azul.svg" alt="Ibancar" />
          </router-link>
        </div>
        <!-- OPCIONES DE MENU EN TOP NAVBAR -->
        <div>
          <!-- Opciones que sólo aparecerán en monitores y desktop -->
          <div id="opciones_desktop">
            <ul>
              <!-- <li><router-link to="/" >Inicio</router-link></li> -->
              <li><router-link to="/credito-coche">Crédito Coche</router-link></li>
              <li><router-link to="/como-funciona">¿Cómo funciona?</router-link></li>
              <li><router-link to="/quienes-somos" rel="nofollow">Quienes Somos</router-link></li>
              <li><a :href="$blogURL" target='_blank' >Blog</a></li>
              <li><router-link to="/contacto">Contacto</router-link></li>
            </ul>
          </div>
          <!-- Fin opciones desktop  -->
          <!-- Opciones que sólo apareceran en Tablets y Móviles -->
          <div id="zona_hamburger">
            <ul class="d-flex flex-row align-items-center">
              <li>
                <a href="tel:+34952864645" aria-label="número de teléfono">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="14" cy="14" r="14" fill="#004680" />
                    <path d="M12.9879 9.96869L10.6198 7.2352C10.3468 6.92021 9.84635 6.92161 9.52925 7.2394L7.58186 9.19029C7.00226 9.77059 6.83636 10.6323 7.17166 11.3232C9.17478 15.4706 12.5197 18.8202 16.6643 20.8291C17.3545 21.1644 18.2155 20.9985 18.7951 20.4182L20.7607 18.4491C21.0792 18.1306 21.0799 17.6273 20.7621 17.3543L18.0181 14.9989C17.7311 14.7525 17.2852 14.7847 16.9975 15.0731L16.0427 16.0293C15.9938 16.0805 15.9295 16.1143 15.8596 16.1254C15.7896 16.1365 15.718 16.1244 15.6556 16.0909C14.0949 15.1921 12.8003 13.8958 11.9036 12.334C11.8701 12.2715 11.8579 12.1997 11.869 12.1297C11.8801 12.0596 11.9139 11.9952 11.9652 11.9462L12.9172 10.9935C13.2056 10.7037 13.2371 10.2557 12.9879 9.96799V9.96869Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </li>
              <li>
                <router-link to="/contacto/#enviarMensaje" aria-label="enviar mensaje">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="14" cy="14" r="14" fill="#004680" />
                    <path d="M20.5 9H7.5C7.22344 9 7 9.20312 7 9.45455V18.5455C7 18.7969 7.22344 19 7.5 19H20.5C20.7766 19 21 18.7969 21 18.5455V9.45455C21 9.20312 20.7766 9 20.5 9ZM19.875 10.5739V17.9773H8.125V10.5739L7.69375 10.2685L8.30781 9.55114L8.97656 10.0241H19.025L19.6938 9.55114L20.3078 10.2685L19.875 10.5739ZM19.025 10.0227L14 13.5739L8.975 10.0227L8.30625 9.54972L7.69219 10.267L8.12344 10.5724L13.4609 14.3452C13.6144 14.4536 13.8033 14.5124 13.9977 14.5124C14.192 14.5124 14.3809 14.4536 14.5344 14.3452L19.875 10.5739L20.3062 10.2685L19.6922 9.55114L19.025 10.0227Z" fill="white" />
                  </svg>
                </router-link>
              </li>
              <li>
                <a href="https://clientes.ibancar.com/" target="_blank" rel="nofollow noopener" aria-label="área de clientes">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="14" cy="14" r="14" fill="#004680" />
                    <path d="M14.2333 14.1384C16.2045 14.1384 17.8025 12.5404 17.8025 10.5692C17.8025 8.59799 16.2045 7 14.2333 7C12.2621 7 10.6641 8.59799 10.6641 10.5692C10.6641 12.5404 12.2621 14.1384 14.2333 14.1384Z" stroke="white" />
                    <path d="M17.8042 15.5664H18.0555C18.5774 15.5666 19.0812 15.7573 19.4724 16.1027C19.8636 16.4481 20.1152 16.9245 20.1799 17.4424L20.459 19.6724C20.4841 19.8733 20.4662 20.0773 20.4064 20.2707C20.3467 20.4641 20.2465 20.6427 20.1125 20.7944C19.9785 20.9462 19.8137 21.0677 19.6292 21.1509C19.4446 21.2342 19.2445 21.2772 19.042 21.2771H9.42799C9.22554 21.2772 9.02538 21.2342 8.84082 21.1509C8.65626 21.0677 8.49151 20.9462 8.3575 20.7944C8.22349 20.6427 8.1233 20.4641 8.06356 20.2707C8.00382 20.0773 7.98591 19.8733 8.01102 19.6724L8.28942 17.4424C8.35416 16.9243 8.60595 16.4477 8.99743 16.1022C9.38891 15.7568 9.89312 15.5662 10.4152 15.5664H10.6658" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </li>
              <li>
                <button @click="triggered($event)" data-trigger="navbar_main" class="d-xl-none navbar-toggler" type="button" aria-label="Toggle navigation">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.08645V0.223633H24V4.08645H0ZM0 13.7435H24V9.88069H0V13.7435ZM0 23.4005H24V19.5377H0V23.4005Z" fill="#004680" />
                  </svg>
                </button>
              </li>
            </ul>
          </div>
          <!-- Fin opciones mobile -->
          <!-- Zona usuario solo visible cuando entra en modo Monitor Desktop -->
        </div>
        <div id="zona_usuarios" class="">
          <a href="https://clientes.ibancar.com/" target="_blank" class="btn btn-outline-warning my-2 my-sm-0" role="button" aria-pressed="true" rel="nofollow noopener">Área Privada ></a>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
window.addEventListener("scroll", () => {
  let navbar = document.getElementById("desktop");
  const scrollY = window.scrollY;
  const screen_width = window.screen.width;
  if (screen_width >= 768 && scrollY > 0) {
    navbar.className = "transition_forward";
  } else {
    navbar.className = "transition_backward";
  }
});
import store from "@/store";
import { mapState } from "vuex";
export default {
  name: "NavBar2",
  emits: ["clicked"],
  el: "#navigation_menu",
  methods: {
    triggered(e) {
      this.$emit("clicked", e.target);
    },
    close_offcanvas(route) {
      let mobile_canvas = document.querySelector(".mobile-offcanvas.show");
      this.$parent.darken_screen(false);
      mobile_canvas ? mobile_canvas.classList.remove("show") : "";
      document.body.classList.remove("offcanvas-active");
      route ? this.$router.push({ path: route }) : null;
    },
  },
  store,
  computed: mapState({
    preload: (state) => state.preload,
    afiliado: (state) => state.afiliado,
  }),
};
</script>

<style scoped lang="scss">
// clases comunes a todas los tamaños
#ibancarLogo {
  &.router-link-active {
    border: none;
  }
  &.router-link-exact-active {
    border: none;
  }
}
.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url("../assets/img/close.svg") center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5;
}
.dropdown-divider {
  height: auto;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.cursor:hover,
.cursor:hover:after,
.cursor:hover:before,
.cursor:hover i,
.cursor:hover span {
  cursor: pointer;
}
.grey {
  color: #333;
}
// Clases específicas según tamaño de pantalla:

@import "bootstrap/scss/_functions.scss";
@import "bootstrap/scss/_variables.scss";
@import "bootstrap/scss/_mixins.scss";
@import "@/assets/styles/variables.scss";

// Pantallas muy pequeñas a pequeñas 0 a 575px

@include media-breakpoint-between(xs, sm) {

  
  #desktop {
    background-color: #fff;
  }
  .offcanvas-header {
    display: block;
  }

  .mobile-offcanvas {
    visibility: unset;
    transform: translateX(100%);
    border-radius: 0 0 0 10px;
    padding-left: 25px;
    display: block;
    position: fixed;
    top: 0;
    right: 0;
    height: auto;
    width: auto;
    z-index: 1200;
    overflow-y: hidden;
    overflow-x: hidden;
    transition: visibility 0.3s ease-in-out, transform 0.3s ease-in-out;
  }

  .mobile-offcanvas.show {
    visibility: visible;
    transform: translateX(0);
  }
  .mobile-offcanvas .container,
  .mobile-offcanvas .container-fluid {
    display: block;
  }
  #logoMenu {
    padding-left: 15px;
  }
  #opciones_desktop {
    display: none;
    visibility: hidden;
  }
  #zona_usuarios {
    display: none;
    visibility: hidden;
  }

  nav li a {
    color: $gray-2;
    text-decoration: none;
    &:hover {
      color: $blue !important;
      border-bottom: $blue solid 5px;
      padding-bottom: 3.5vh;
      text-decoration: none;
      .h4 {
        color: $blue !important;
      }
      .color-svg path {
        fill: $blue !important;
      }
    }
    &:focus {
      border-bottom: $blue solid 5px !important;
      padding-bottom: 3.5vh;
      text-decoration: none;
    }
    &.router-link-exact-active {
      color: $blue;
      font-weight: bold;
    }
  }
  .h4 {
    color: #333 !important;
    font-size: 0.95rem;
    &.router-link-exact-active {
      color: $blue !important;
      font-weight: bold;
    }
  }
  span:hover {
    cursor: pointer;
  }
}
// Pantallas de 576 a 767px
@include media-breakpoint-between(sm, md) {
}

// Pantallas medianas a Grandes 767px a 991px
@include media-breakpoint-only(md) {
  @keyframes fadeToWhite {
    from {
      background-color: transparent;
    }
    to {
      background-color: #fff;
    }
  }

  @keyframes fadeToTransparent {
    from {
      background-color: #fff;
    }
    to {
      background-color: transparent;
    }
  }
  .transition_forward {
    padding: 0;
    background: transparent;
    animation: fadeToWhite 1.5s;
    animation-fill-mode: forwards;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  }

  .transition_backward {
    padding: 0%;
    background: transparent;
    animation: fadeToTransparent 1.5s;
    animation-fill-mode: forwards;
  }
  .offcanvas-header {
    display: block;
  }

  .mobile-offcanvas {
    visibility: unset;
    transform: translateX(100%);
    border-radius: 0 0 0 10px;
    display: block;
    position: fixed;
    top: 0;
    right: 0;
    height: auto;
    width: auto;
    z-index: 1200;
    overflow-y: hidden;
    overflow-x: hidden;
    transition: visibility 0.3s ease-in-out, transform 0.3s ease-in-out;
  }

  .mobile-offcanvas.show {
    visibility: visible;
    transform: translateX(0);
  }
  .mobile-offcanvas .container,
  .mobile-offcanvas .container-fluid {
    display: block;
  }
  #logoMenu {
    padding-left: 50px;
  }
  #zona_hamburger {
    padding-right: 30px;
  }
  #opciones_desktop {
    display: none;
    visibility: hidden;
  }
  #zona_usuarios {
    display: none;
    visibility: hidden;
  }
  nav li a {
    color: $gray-2;
    text-decoration: none;
    &:hover {
      color: $blue !important;
      border-bottom: $blue solid 5px;
      padding-bottom: 3.5vh;
      text-decoration: none;
      .h4 {
        color: $blue !important;
      }
      .color-svg path {
        fill: $blue !important;
      }
    }
    &:focus {
      border-bottom: $blue solid 5px !important;
      padding-bottom: 3.5vh;
      text-decoration: none;
    }
    &.router-link-active {
      color: $blue;
      font-weight: bold;
      border-bottom: $blue solid 5px !important;
      padding-bottom: 3.5vh;
    }
    &.router-link-exact-active {
      color: $blue;
      font-weight: bold;
      border-bottom: $blue solid 5px !important;
      padding-bottom: 3.5vh;
    }
  }
  .h4 {
    color: #333 !important;
    font-size: 0.95rem;
  }
}

@include media-breakpoint-only(lg) {
  @keyframes fadeToWhite {
    from {
      background-color: transparent;
    }
    to {
      background-color: #fff;
    }
  }

  @keyframes fadeToTransparent {
    from {
      background-color: #fff;
    }
    to {
      background-color: transparent;
    }
  }


  .transition_forward {
    padding: 0;
    background: transparent;
    animation: fadeToWhite 1.5s;
    animation-fill-mode: forwards;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  }

  .transition_backward {
    padding: 0%;
    background: transparent;
    animation: fadeToTransparent 1.5s;
    animation-fill-mode: forwards;
  }
  .offcanvas-header {
    display: block;
  }

  .mobile-offcanvas {
    visibility: unset;
    transform: translateX(100%);
    border-radius: 0 0 0 10px;
    display: block;
    position: fixed;
    top: 0;
    right: 0;
    height: auto;
    width: auto;
    z-index: 1200;
    overflow-y: hidden;
    overflow-x: hidden;
    transition: visibility 0.3s ease-in-out, transform 0.3s ease-in-out;
  }

  .mobile-offcanvas.show {
    visibility: visible;
    transform: translateX(0);
  }
  .mobile-offcanvas .container,
  .mobile-offcanvas .container-fluid {
    display: block;
  }
  #logoMenu {
    padding-left: 50px;
  }
  #zona_hamburger {
    padding-right: 30px;
  }
  #opciones_desktop {
    display: none;
    visibility: hidden;
  }
  #zona_usuarios {
    display: none;
    visibility: hidden;
  }
  nav li a {
    color: $gray-2;
    text-decoration: none;
    &:hover {
      color: $blue !important;
      border-bottom: $blue solid 5px;
      padding-bottom: 3.5vh;
      text-decoration: none;
      .h4 {
        color: $blue !important;
      }
      .color-svg path {
        fill: $blue !important;
      }
    }
    &:focus {
      border-bottom: $blue solid 5px !important;
      padding-bottom: 3.5vh;
      text-decoration: none;
    }
    &.router-link-active {
      color: $blue;
      font-weight: bold;
      border-bottom: $blue solid 5px !important;
      padding-bottom: 3.5vh;
    }
    &.router-link-exact-active {
      color: $blue;
      font-weight: bold;
      border-bottom: $blue solid 5px !important;
      padding-bottom: 3.5vh;
    }
  }
  .h4 {
    color: #333 !important;
    font-size: 0.95rem;
  }
}

// Pantallas lg y xxl 992px a 1199px
@include media-breakpoint-only(xl) {
  @keyframes fadeToWhite {
    from {
      background-color: transparent;
    }
    to {
      background-color: #fff;
    }
  }

  @keyframes fadeToTransparent {
    from {
      background-color: #fff;
    }
    to {
      background-color: transparent;
    }
  }
  .transition_forward {
    padding: 0;
    background: transparent;
    animation: fadeToWhite 1.5s;
    animation-fill-mode: forwards;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  }
  .transition_backward {
    padding: 0%;
    background: transparent;
    animation: fadeToTransparent 1.5s;
    animation-fill-mode: forwards;
  }
  #navbar_main {
    display: none;
  }
  #zona_hamburger {
    display: none;
    visibility: hidden;
  }
  #logoMenu {
    // padding-left: 5vw;
  }
  #zona_usuarios a {
    // padding-right: 50px;
    // padding-left: 50px;
  }
  #zona_usuarios {
    // padding-right: 3.2vh;
  }

  nav li a {
    color: $blue;
    font-weight: bold;
    text-decoration: none;
    &:hover {
      color: $blue !important;
      border-bottom: $blue solid 5px;
      padding-bottom: 3.5vh;
      text-decoration: none;
      .h4 {
        color: $blue !important;
      }
      .color-svg path {
        fill: $blue !important;
      }
    }
    &:focus {
      border-bottom: $blue solid 5px !important;
      padding-bottom: 3.5vh;
      text-decoration: none;
    }
    &.router-link-active {
      color: $blue;
      font-weight: bold;
      padding-bottom: 3.5vh;
      border-bottom: $blue solid 5px;
    }
    &.router-link-exact-active {
      color: $blue;
      font-weight: bold;
      padding-bottom: 3.5vh;
      border-bottom: $blue solid 5px;
    }
  }
  .btn-outline-warning {
    color: $blue !important;
    font-weight: bold;
    border-color: $blue;
    background: transparent;
    animation: fadeToTransparent 1.5s;
    animation-fill-mode: forwards;
  }

  .btn-outline-warning:hover {
    background-color: $dark-blue !important;
    color: $white !important;
  }

  .btn-outline-warning:active {
    background-color: $blue !important;
    color: $white !important;
  }

}
</style>
